// extracted by mini-css-extract-plugin
module.exports = {"label":"Labels_label__b2WRf","labels":"Labels_labels__Xac2d","titleRoot":"Labels_titleRoot__5B8LI","horizontal":"Labels_horizontal__wpkMk"};